import { render } from "./CustomContentModal.vue?vue&type=template&id=20525187&scoped=true"
import script from "./CustomContentModal.vue?vue&type=script&lang=js"
export * from "./CustomContentModal.vue?vue&type=script&lang=js"

import "./CustomContentModal.vue?vue&type=style&index=0&id=20525187&lang=sass&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20525187"]])

export default __exports__